import React, { FC, useContext, useState } from 'react';
import { Icon, Input } from 'semantic-ui-react';
import { AuthZeroApolloContext } from '@src/views/components/util/external/AuthZeroApolloClient';
import { useCentralCalls } from '@src/rest/CentralCalls';



const AIModel: FC = () => {
    const [ aiSearchValue, setAiSearchValue ]     = useState( '' ),
          [ aiResponse, setAiResponse ]           = useState( '' ),
          [ isTyping, setIsTyping ]               = useState( false ),
          [ showResponseBox, setShowResponseBox ] = useState( false );
    const { currentToken } = useContext(AuthZeroApolloContext);
    const {GetAIResponse} = useCentralCalls();
    const handleAiSearchKeyDown = async (event) => {
        if (event.key === 'Enter') {
            setAiResponse('');
            setAiSearchValue('');
            setShowResponseBox(true);
            setIsTyping(true);

            let loadingDots = '.';
            let isApiCallFinished = false;

            const loadingEffect = () => {
                if (isApiCallFinished) return;
                if (loadingDots.length < 3) {
                    loadingDots += '.';
                } else {
                    loadingDots = '';
                }
                setAiResponse(loadingDots);
                setTimeout(loadingEffect, 200);
            };

            loadingEffect();
            console.log("IN AI FLOATING MODEL...");
            const response = await GetAIResponse('', aiSearchValue, []);
            //const response = await processAiInput(aiSearchValue, currentToken);
            isApiCallFinished = true;

            setAiResponse('');
            let currentIndex = 0;

            const typingEffect = () => {
                if (currentIndex < response.length) {
                    setAiResponse((prev) => prev + response[currentIndex]);
                    currentIndex++;
                    setTimeout(typingEffect, 15);
                } else {
                    setIsTyping(false);
                }
            };

            typingEffect();
        }
    };

    const handleAiSearchChange = (event) => {
        setAiSearchValue(event.target.value);
    };

    const handleCloseResponseBox = () => {
        setShowResponseBox(false);
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Input
                    iconPosition='left'
                    placeholder='Ask Cor-IQ...'
                    style={{ borderRadius: '35px', overflow: 'hidden' }}
                    onKeyDown={handleAiSearchKeyDown}
                    value={aiSearchValue}
                    onChange={handleAiSearchChange}
                >
                    <Icon name='medapps' />
                    <input style={{ borderRadius: '35px', paddingLeft: '40px' }} />
                </Input>

                {showResponseBox && (
                    <div style={{
                        marginTop: '10px', // Adjust to position below the input
                        width: '90%',
                        background: '#fff',
                        borderRadius: '10px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        fontSize: '14px',
                    }}>
                        <button
                            onClick={handleCloseResponseBox}
                            style={{
                                alignSelf: 'flex-end',
                                background: 'transparent',
                                border: 'none',
                                fontSize: '16px',
                                cursor: 'pointer',
                            }}
                        >
                            &times;
                        </button>
                        <div>
                            <strong>Cor-IQ:</strong>
                        </div>
                        <div style={{ whiteSpace: 'pre-wrap' }}>
                            {aiResponse}
                            {isTyping && <span className="blinking-cursor">|</span>}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default AIModel;